import React, { Component, useState, useEffect } from "react";
import { Trans, useTranslation, withTranslation } from "react-i18next";
import MaterialTable from "@material-table/core";

import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { ProgressBar } from "react-step-progress-bar";
import "react-step-progress-bar/styles.css";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginFileMetadata from "filepond-plugin-file-metadata";
import "filepond/dist/filepond.min.css";
import DialogContentText from "@material-ui/core/DialogContentText";
import Snackbar from "@material-ui/core/Snackbar";
import WarningIcon from "@material-ui/icons/Warning";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { attachmentClient } from "../AxiosClient";
import KpsEditor from "../components/editor/KpsEditor";
import { DatePicker } from "@material-ui/pickers";
import UploadError from "../components/messages/UploadError";

const getTransKeyFromHttpStatus = (status, message) => {
  let translationKey = "unexpected_upload_error";
  switch (status) {
    case 409:
      translationKey = "virus_detected_in_file";
      break;
    case 413:
      translationKey = "file_too_big_to_process";
      break;
    case 418:
      // I'm a teapot.
      // Temporary method to handle internal 500 errors. See UV6-1207
      // Error type is propagated as a translation key
      // First characters are the Http status it prepresents
      // e.g. 500_AV_NOT_DEFINED
      if (!!message && message.length > 0) {
        translationKey = message;
      }
  }
  return translationKey;
};

const styles = (theme) => ({
  paper: {
    margin: 10,
    marginTop: 20,
    flex: 1,
  },
  fab: {
    position: "absolute",
    bottom: theme.spacing(3),
    right: theme.spacing(3),
  },
  globalRequestIcon: {
    color: "#2196F3",
  },
  unusedNotGlobalIcon: {
    color: "#F44336",
  },
  header: {
    fontWeight: "bold",
    padding: 10,
  },
  paddedText: {
    paddingLeft: 10,
  },
  unusedBar: {
    margin: "5px 20px 20px 20px",
  },
});
function uploadDateFilter(props) {
  const [uploadBefore, setUploadBefore] = useState(null);
  const [uploadAfter, setUploadAfter] = useState(null);

  useEffect(
    () => {
      props.onFilterChanged(props.columnDef.tableData.id, {
        uploadBefore,
        uploadAfter,
      });
    },
    [uploadBefore, uploadAfter]
  );
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <DatePicker
        autoOk
        label={"After"}
        clearable
        value={uploadAfter}
        minDate={new Date()}
        onChange={(date) => {
          setUploadAfter(date);
        }}
      />
      <DatePicker
        autoOk
        label={"Before"}
        minDate={new Date()}
        clearable
        disableFuture
        value={uploadBefore}
        onChange={(date) => {
          setUploadBefore(date);
        }}
      />
    </div>
  );
}
export class ManageAttachments extends Component {
  state = {
    unfilteredAttachments: [],
    attachments: [],
    unusedNotGlobal: 0,
    globalUnused: 0,
    pendingGlobalRequest: 0,
    description: "",
    descriptionDisabled: false,
    files: [],
    deleteDialogOpen: false,
    attachmentToDelete: -1,
    hasUnusedNotGlobalFilter: false,
    hasPendingGlobalRequestFilter: false,
    totalUnused: 0,
    pageSize: 5,
    startIndex: 0,
    content: new Map(),
    tableRef: React.createRef(),
    apiLocation: "",
    totalAttachments: 0,
    unusedAttachments: 0,
    AwaitingGlobalAttachments: 0,
    UnusedAndNotGlobal: 0,
    totalElements: 0,
    columns: [],
    uploadError: null,
    useOfAttachmentIds:[],
    contentResponse:false,
    detailsResponse:false,
  };

  getData = (query, resolve, reject) => {
    if (!this.props.editorDialog) {
      this.getDetails(reject);
    }
    let params = {};
    query.filters.map((filter) => {
      if (filter.column.field === "global") {
        filter.value === "unchecked"
          ? (params.global = false)
          : filter.value === "checked"
            ? (params.global = true)
            : (params.global = null);
      } else if (filter.column.field === "uploadDate") {
        if (filter.value.uploadAfter) {
          params.uploadAfter = Date.parse(filter.value.uploadAfter);
        }
        if (filter.value.uploadBefore) {
          params.uploadBefore = Date.parse(filter.value.uploadBefore);
        }
      } else {
        params[filter.column.field] = filter.value;
      }
    });
    if (this.props.editorDialog) {
      params.global = true;
    }
    if (query.orderBy && query.orderBy.field) {
      params.sortBy = query.orderBy.field;
      params.sortOrder = query.orderDirection;
    }
    this.setState({ pageSize: query.pageSize });
    attachmentClient
      .get(`/attachment/`, {
        params: {
          ...params,
          page: query.page,
          size: query.pageSize,
        },
        cache: false,
      })
      .then((res) => {
        this.setState({ totalElements: res.data.totalElements });
        let content = [...res.data.content];
        content.forEach((item, index, theArray)=> {
          theArray[index].timesUsed = this.state.useOfAttachmentIds.filter((v) => (v === item.id)).length;
        });
        resolve({
          data: content,
          page: res.data.number,
          totalCount: res.data.totalElements,
        });
      })
      .catch((err) => {
        reject(err);
      });
    // if (!this.props.editorDialog) {
    //   this.getDetails(reject);
    // }
  };

  getDetails = (reject) => {
    attachmentClient
      .get(`/attachment/details/`)
      .then((res) => {
        this.setState({
          unusedAttachments: res.data.unusedAttachments,
          AwaitingGlobalAttachments: res.data.awaitingGlobal,
          UnusedAndNotGlobal: res.data.unusedAndNotGlobal,
          totalAttachments: res.data.totalAttachments,
          useOfAttachmentIds: res.data.useOfAttachmentIds,
          detailsResponse: true,
        });
      })
      .catch((err) => {
        reject && reject(err);
      });
  };

  getContent = (id, contentType, event) => {
    if (contentType === "image/jpeg" || contentType === "image/png") {
      attachmentClient.get(`/attachment/${id}/content/`).then((res) => {
        let contentTemp = this.state.content;
        contentTemp.set(id, res.data);
        this.setState({ content: contentTemp });
      });
    }
  };
  base64ToArrayBuffer = (base64) => {
    var binary_string = window.atob(unescape(encodeURIComponent(base64)));
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  };
  componentDidMount(prevProps) {
    this.getDetails();
    registerPlugin(FilePondPluginFileMetadata);
    const { classes, t } = this.props;
    const columns = [
      {
        title: this.props.t("manage_attachments_column_filename"),
        field: "sourceFileName",
        editable: "never",
      },
      {
        title: this.props.t("manage_attachments_column_filetype"),
        field: "contentType",
        editable: "never",
      },
      {
        title: this.props.t("manage_attachments_column_description"),
        field: "description",
      },
      {
        title: this.props.t("manage_attachments_column_date_uploaded"),
        field: "uploadDate",
        type: "date",
        editable: "never",
        filterComponent: uploadDateFilter,
      },
      {
        title: this.props.t("manage_attachments_column_attachment_size"),
        field: "contentSize",
        type: "numeric",
        editable: "never",
      },
      {
        title: this.props.t("manage_attachments_column_times_used"),
        field: "timesUsed",
        sorting: false,
        type: "numeric",
        editable: "never",
        filtering: false,
      },
      {
        title: this.props.t("global_global"),
        field: "global",
        type: "boolean",
      },
    ];

    !this.props.editorDialog &&
      columns.unshift({
        title: <Trans i18nKey="manage_attachments_column_alerts" />,
        field: "alerts",
        sorting: false,
        render: (rowData) => {
          if (rowData.globalRequest) {
            return (
              <Tooltip
                title={
                  <Trans i18nKey="manage_attachments_approve_global_request" />
                }
              >
                <IconButton
                  className={classes.globalRequestIcon}
                  onClick={() => {
                    this.setState({ attachmentToApprove: rowData }, () =>
                      this.approveGlobalRequest()
                    );
                  }}
                >
                  <ThumbUpIcon />
                </IconButton>
              </Tooltip>
            );
          } else if (
            rowData.timesUsed === 0 &&
            !rowData.global &&
            !rowData.globalRequest
          ) {
            return (
              <Tooltip
                title={<Trans i18nKey="manage_attachments_unused_not_global" />}
              >
                <IconButton
                  className={classes.unusedNotGlobalIcon}
                  onClick={() => {
                    this.setState({ attachmentToDelete: rowData }, () =>
                      this.setState({ deleteDialogOpen: true })
                    );
                  }}
                >
                  <ErrorOutlineIcon />
                </IconButton>
              </Tooltip>
            );
          }
        },
        cellStyle: { textAlign: "center" },
        filtering: false,
        editable: "never",
      });
    this.setState({ columns });
  }
  canSelect = (rowData) => {
    if (!this.props.selectedAttachment.id) {
      return true;
    } else if (rowData.id === this.props.selectedAttachment.id) {
      return true;
    } else {
      return false;
    }
  };
  // processAttachments = (attachments) => {
  //   let unusedNotGlobal = 0;
  //   let globalUnused = 0;
  //   let pendingGlobalRequest = 0;
  //   let totalUnused = 0;
  //   let attachmentsProcessed = attachments.content.map((a) => {
  //     a.timesUsed=this.state.data.useOfAttachmentIds.filter((v) => (v === a.id)).length;
  //     if (a.timesUsed === 0) {
  //       totalUnused++;
  //     }
  //     if (a.timesUsed === 0 && !a.global && !a.globalRequest) {
  //       a.unusedNotGlobal = true;
  //       unusedNotGlobal++;
  //     }
  //     if (a.globalRequest) {
  //       pendingGlobalRequest++;
  //     }
  //     return a;
  //   });
  //   this.setState(
  //     {
  //       unfilteredAttachments: attachmentsProcessed,
  //       attachments: attachmentsProcessed,
  //       unusedNotGlobal,
  //       globalUnused,
  //       pendingGlobalRequest,
  //       totalUnused,
  //     },
  //     () => {
  //       this.applyFilter();
  //     }
  //   );
  // };

  render() {
    const { classes, t } = this.props;
    return (
      <div
        style={{
          padding: 10,
          height: "100%",
          overflow: "auto",
          backgroundColor: "#eae0d7",
          backgroundImage: "url('../images/background.svg')",
        }}
      >
        {!this.props.editorDialog && (
          <div style={{ display: "flex" }}>
            <Paper className={classes.paper}>
              <Typography className={classes.header}>
                <Trans i18nKey="manage_attachments_outstanding_actions" />
              </Typography>
              <Typography className={classes.paddedText}>
                <a
                  href="javascript:undefined"
                  onClick={this.applyUnusedNotGlobalFilter}
                >
                  <Trans
                    i18nKey={
                      this.state.unusedNotGlobal === 1
                        ? "manage_attachments_singular_unused_not_global"
                        : "manage_attachments_plural_unused_not_global"
                    }
                    values={{ number: this.state.UnusedAndNotGlobal }}
                  />
                </a>
              </Typography>
              <Typography className={classes.paddedText}>
                <a
                  href="javascript:undefined"
                  onClick={this.applyPendingGlobalRequestFilter}
                >
                  <Trans
                    i18nKey={
                      this.state.pendingGlobalRequest === 1
                        ? "manage_attachments_singular_pending_global_request"
                        : "manage_attachments_plural_pending_global_request"
                    }
                    values={{ number: this.state.AwaitingGlobalAttachments }}
                  />
                </a>
              </Typography>

              {(this.state.hasGlobalUnusedFilter ||
                this.state.hasUnusedNotGlobalFilter ||
                this.state.hasPendingGlobalRequestFilter) && (
                <Typography style={{ padding: 10 }}>
                  <WarningIcon color="error" />
                  <a href="javascript:undefined" onClick={this.resetFilters}>
                    <Trans i18nKey="manage_attachments_table_active_filter" />
                  </a>
                </Typography>
              )}
            </Paper>
            <Paper className={classes.paper}>
              <Typography className={classes.header}>
                <Trans i18nKey="manage_attachments_statistics" />
              </Typography>
              <div className={classes.unusedBar}>
                <Typography>
                  <Trans
                    i18nKey="manage_attachments_num_unused"
                    values={{
                      unused: this.state.unusedAttachments,
                      total: this.state.totalAttachments,
                    }}
                  />
                </Typography>
                <ProgressBar
                  filledBackground="#FFC107"
                  percent={
                    (this.state.unusedAttachments /
                      this.state.totalAttachments) *
                    100
                  }
                />
              </div>
            </Paper>
          </div>
        )}
        {this.state.detailsResponse &&
          <div style={{ overflow: "auto" }}>
            <MaterialTable
              tableRef={this.state.tableRef}
              columns={this.state.columns}
              data={(query) =>
                new Promise((resolve, reject) => {
                  this.getData(query, resolve, reject);
                })
              }
              editable={
                !this.props.editorDialog
                  ? {
                      onRowUpdate: (newData) => {
                        return new Promise((resolve) => {
                          attachmentClient
                            .patch(`/attachment/${newData.id}`, {
                              ...newData,
                            })
                            .then(() => {
                              this.state.tableRef.current &&
                                this.state.tableRef.current.onQueryChange();
                            });
                          resolve();
                        });
                      },
                    }
                  : null
              }
              actions={
                !this.props.editorDialog && [
                  (rowData) => ({
                    icon: "delete",
                    ariaLabel: "test",
                    tooltip: t("manage_attachments_delete_tooltip"),
                    disabled: rowData.userAdded === 0,
                    onClick: (_e, rowData) => {
                      this.setState({ attachmentToDelete: rowData }, () =>
                        this.setState({ deleteDialogOpen: true })
                      );
                    },
                  }),
                  (rowData) =>
                    !rowData.global && {
                      icon: () => <ThumbUpIcon />,
                      tooltip: "Make global",
                      onClick: (event, rowData) => {
                        this.setState({ attachmentToApprove: rowData }, () =>
                          this.approveGlobalRequest()
                        );
                      },
                    },
                ]
              }
              detailPanel={[
                {
                  tooltip: "Show attachment",
                  render: ({ rowData }) => {
                    let slateTag = null;
                    if (!rowData.contentType) {
                      return <div />;
                    }
                    if (rowData.contentType === "application/pdf") {
                      slateTag = `<div class="pdf-container" data-attachment='${
                        rowData.id
                      }' id='docCtr-${
                        rowData.id
                      }' style="height: 700px; overflow: auto; position: relative;"><div id="ctr-${
                        rowData.id
                      }"><div class="pdfViewer">&nbsp;</div></div></div>`;
                    } else if (
                      rowData.contentType === "image/jpeg" ||
                      rowData.contentType === "image/png"
                    ) {
                      slateTag = `<img alt src="https://${
                        this.props.apiLocation
                      }/attachmentservice/attachment/${
                        rowData.id
                      }/content/" />`;
                    } else if (rowData.contentType.includes("video/")) {
                      slateTag = `<div class="ckeditor-html5-video" style="text-align: center;"><video controls  controlslist="nodownload" src="https://${
                        this.props.apiLocation
                      }/attachmentservice/attachment/${
                        rowData.id
                      }/content/">&nbsp;</video></div>`;
                    } else {
                      slateTag = `<a data-cke-saved-href="https://${
                        this.props.apiLocation
                      }/attachmentservice/attachment/${
                        rowData.id
                      }/content" href="https://${
                        this.props.apiLocation
                      }/attachmentservice/attachment/${
                        rowData.id
                      }/content" data-attachment="${
                        rowData.id
                      }" class="file-attachment file-attachment-download">${
                        rowData.sourceFileName
                      }</a>`;
                    }
                    return (
                      <div>
                        {rowData.userLogin && (
                          <Trans
                            i18nKey="manage_attachments_uploaded_by"
                            values={{
                              user: `${rowData.userLogin.firstName} ${
                                rowData.userLogin.lastName
                              } (${rowData.userLogin.userLogin})`,
                            }}
                          />
                        )}
                        <br />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flex: 1,
                            padding: "12px",
                            overflow: "auto",
                            maxWidth: "100%",
                          }}
                        >
                          <div style={{ width: "100%" }} />
                          <KpsEditor readOnly initialContent={slateTag} />
                          <div style={{ width: "100%" }} />
                        </div>
                      </div>
                    );
                  },
                },
              ]}
              options={{
                pageSize: this.state.pageSize,
                pageSizeOptions: [5, 10, 15, 20],
                filtering: true,
                headerStyle: { position: "sticky", top: 0 },
                actionsColumnIndex: -1,
                selection: this.props.editorDialog ? true : false,
                showSelectAllCheckbox: false,
                showTextRowsSelected: false,
                selectionProps:
                  this.props.editorDialog &&
                  ((rowData) => ({
                    disabled: !this.canSelect(rowData),
                    color: "primary",
                  })),
              }}
              onSelectionChange={(rows) => {
                if (this.props.onSelection) {
                  this.props.onSelection(rows.length > 0 ? rows[0] : {});
                }
              }}
              onRowClick={(_event, _rowData, togglePanel) => (
                togglePanel(), this.getContent(_rowData.id, _rowData.contentType)
              )}
              title={t("global_attachment_plural")}
            />
          </div>
    }
        <Dialog
          fullWidth
          open={this.state.uploadDialogOpen}
          onClose={this.handleUploadDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <Trans i18nKey="manage_attachments_upload_new" />
          </DialogTitle>
          <DialogContent>
            <TextField
              label={t("manage_attachments_description")}
              value={this.state.description}
              onChange={this.handleDescriptionChange}
              margin="normal"
              disabled={this.state.descriptionDisabled}
              aria-label="Attachment description text input"
              fullWidth
            />
            {this.state.description.length === 0 && (
              <Typography>
                <Trans i18nKey="manage_attachments_enter_description_before_upload" />
              </Typography>
            )}
            <FilePond
              files={this.state.files}
              allowMultiple={false}
              allowRevert={false}
              disabled={this.state.description.length === 0}
              server={{
                process: (
                  fieldName,
                  file,
                  metadata,
                  load,
                  error,
                  progress,
                  abort,
                  transfer,
                  options
                ) => {
                  const formData = new FormData();
                  formData.append("file", file, file.name);
                  formData.append(
                    "contentAttachmentDTO",
                    JSON.stringify({
                      description: this.state.description,
                      globalRequest: this.state.globalRequest,
                    })
                  );
                  const request = new XMLHttpRequest();
                  request.withCredentials = true
                  request.open(
                    "POST",
                    `https://${
                      this.props.apiLocation
                    }/attachmentservice/attachment/upload/`
                  );
                  request.upload.onprogress = (e) => {
                    progress(e.lengthComputable, e.loaded, e.total);
                  };
                  request.onload = () => {
                    let payload = JSON.parse(request.responseText);
                    if (request.status >= 200 && request.status < 300) {
                      load(payload.id);
                    } else {
                      let key = getTransKeyFromHttpStatus(
                        request.status,
                        payload.message
                      );
                      error(t(key));
                      this.setState({ uploadError: key });
                    }
                  };
                  request.send(formData);
                  return {
                    abort: () => {
                      request.abort();
                      abort();
                    },
                  };
                },
              }}
              onprocessfile={(_err, file) => {
                if (!_err) {
                  this.handleUploadDialogClose();
                  this.state.tableRef.current &&
                    this.state.tableRef.current.onQueryChange();
                }
              }}
              onupdatefiles={(fileItems) => {
                // Set currently active file objects to this.state
                this.setState({
                  files: fileItems.map((fileItem) => fileItem.file),
                  descriptionDisabled: fileItems.length === 1,
                });
              }}
              onaddfilestart={(file) => {
                file.setMetadata("description", this.state.description);
                file.setMetadata("isGlobal", true);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleUploadDialogClose} color="primary">
              <Trans i18nKey="global_close" />
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.deleteDialogOpen}
          onClose={this.handleDeleteDialogClose}
          aria-labelledby="delete-dialog-title"
          aria-describedby="delete-dialog-description"
        >
          <DialogTitle id="delete-dialog-title">
            <Trans i18nKey="global_are_you_sure" />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="delete-dialog-description">
              <Trans i18nKey="manage_attachments_delete_confirm" />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDeleteDialogClose} color="primary">
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button color="secondary" onClick={this.deleteConfirm}>
              <Trans i18nKey="global_delete" />
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.deletedSnackbarOpen}
          autoHideDuration={6000}
          onClose={this.handleSnackbarClose("deletedSnackbarOpen")}
          message={t("manage_attachments_deleted_snack")}
        />
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.updatedSnackbarOpen}
          autoHideDuration={6000}
          onClose={this.handleSnackbarClose("updatedSnackbarOpen")}
          message={t("manage_attachments_updated_snack")}
        />
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.globalRequestSnackbarOpen}
          autoHideDuration={6000}
          onClose={this.handleSnackbarClose("globalRequestSnackbarOpen")}
          message={t("manage_attachments_request_approved_snack")}
        />
        {!this.props.editorDialog && (
          <Fab
            color="primary"
            aria-label="Add attachment"
            className={classes.fab}
            onClick={() => this.setState({ uploadDialogOpen: true })}
          >
            <AddIcon />
          </Fab>
        )}
        <UploadError
          uploadError={this.state.uploadError}
          setUploadError={() => this.setState({ uploadError: null })}
        />
      </div>
    );
  }
  applyFilter = () => {
    if (this.state.hasUnusedNotGlobalFilter) {
      this.applyUnusedNotGlobalFilter();
    } else if (this.state.hasPendingGlobalRequestFilter) {
      this.applyPendingGlobalRequestFilter();
    }
  };

  approveGlobalRequest = () => {
    let attachmentRVO = {
      ...this.state.attachmentToApprove,
      global: true,
      globalRequest: false,
    };
    attachmentClient
      .patch(`/attachment/${this.state.attachmentToApprove.id}`, {
        ...attachmentRVO,
      })
      .then(() => {
        if (this.state.attachmentToApprove) {
          this.setState({
            globalRequestSnackbarOpen: true,
            attachmentToApprove: null,
          });
        } else {
          this.setState({ updatedSnackbarOpen: true });
        }
        this.state.tableRef.current &&
          this.state.tableRef.current.onQueryChange();
      });
  };

  resetFilters = () => {
    this.setState({
      attachments: JSON.parse(JSON.stringify(this.state.unfilteredAttachments)),
      hasUnusedNotGlobalFilter: false,
      hasPendingGlobalRequestFilter: false,
    });
  };

  applyUnusedNotGlobalFilter = () => {
    this.setState({
      attachments: this.state.unfilteredAttachments.filter(
        (ele) => ele.unusedNotGlobal
      ),
      hasUnusedNotGlobalFilter: true,
      hasPendingGlobalRequestFilter: false,
    });
  };

  applyPendingGlobalRequestFilter = () => {
    this.setState({
      attachments: this.state.unfilteredAttachments.filter(
        (ele) => ele.globalRequest
      ),
      hasPendingGlobalRequestFilter: true,
      hasUnusedNotGlobalFilter: false,
    });
  };

  handleSnackbarClose = (stateKey) => () => {
    this.setState({ [stateKey]: false });
  };

  handleDeleteDialogClose = () => {
    this.setState({ deleteDialogOpen: false });
  };

  deleteConfirm = () => {
    attachmentClient
      .delete(`/attachment/${this.state.attachmentToDelete.id}`)
      .then(() => {
        this.handleDeleteDialogClose();
        this.setState({ deletedSnackbarOpen: true, attachmentToDelete: null });
        this.state.tableRef.current && this.state.tableRef.current.onQueryChange();
      });
  };

  handleCheckboxChange = (e) => {
    this.setState({ isGlobal: e.target.checked });
  };

  handleDescriptionChange = (e) => {
    this.setState({ description: e.target.value });
  };

  handleUploadDialogClose = () => {
    this.setState({ uploadDialogOpen: false, files: [], description: "" });
  };
}

const mapStateToProps = (state) => ({
  apiLocation: state.setting.apiLocation,
});

export default connect(
  mapStateToProps,
  null
)(withTranslation()(withStyles(styles)(ManageAttachments)));
